import { Component, HostBinding } from '@angular/core';
import { ResponsiveSetting } from 'shared/responsive-settings/responsive-settings.interface';

import { SliceBaseRenderComponent } from 'extensions/core/slice-base/render/slice-base-render.component';
import { SliceUserSegmentsSettings } from 'extensions/core/slice-user-segments/front/slice-user-segments-settings.model';


@Component({
  selector: 'slice-user-segments-render',
  templateUrl: './slice-user-segments-render.component.html',
  styleUrls: ['./slice-user-segments-render.component.scss']
})
export class SliceUserSegmentsRenderComponent extends SliceBaseRenderComponent {

  @HostBinding('style.opacity')
  public get opacity(): number {
    const opacity = this.slice.settings?.styles.opacity;
    return [undefined, null, ''].includes(opacity) ? 1 : opacity / 100;
  }

  @HostBinding('attr.data-user-segments')
  public get userSegmentsData(): string {
    const segments = (this.slice.settings as SliceUserSegmentsSettings).general.userSegments;
    return segments.join(',');
  }

  protected onSliceInit(): void {
    // Empty
  }

  protected setDefaultHostStyles(): void {
    this.backgroundColor = this.slice.settings?.styles.bgColor || '';
    this.marginTop = this.slice.settings?.styles.marginTop || '';
    this.marginRight = this.slice.settings?.styles.marginRight || '';
    this.marginLeft = this.slice.settings?.styles.marginLeft || '';
    this.marginBottom = this.slice.settings?.styles.marginBottom || '';
    this.paddingTop = this.slice.settings?.styles.paddingTop || '';
    this.paddingRight = this.slice.settings?.styles.paddingRight || '';
    this.paddingLeft = this.slice.settings?.styles.paddingLeft || '';
    this.paddingBottom = this.slice.settings?.styles.paddingBottom || '';
  }

  protected setResponsiveHostStyles(
    breakpointStyles: ResponsiveSetting,
    defaultBpSettings: Partial<ResponsiveSetting>
  ): void {
    this.backgroundColor = this.slice.settings?.styles.bgColor || '';
    this.marginTop = breakpointStyles.marginTop || defaultBpSettings.marginTop || '';
    this.marginRight = breakpointStyles.marginRight || defaultBpSettings.marginRight || '';
    this.marginLeft = breakpointStyles.marginLeft || defaultBpSettings.marginLeft || '';
    this.marginBottom = breakpointStyles.marginBottom || defaultBpSettings.marginBottom || '';
    this.paddingTop = breakpointStyles.paddingTop || defaultBpSettings.paddingTop || '';
    this.paddingRight = breakpointStyles.paddingRight || defaultBpSettings.paddingRight || '';
    this.paddingLeft = breakpointStyles.paddingLeft || defaultBpSettings.paddingLeft || '';
    this.paddingBottom = breakpointStyles.paddingBottom || defaultBpSettings.paddingBottom || '';
  }

}
